import asyncActionTypes from '../actions/types.js';
import storage from '../../scripts/utilities/storage-manager';


const initialState = {
  loading: false,
  airportsLite: {},
};

const airportsLite = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_CMS_AIRPORTS_LITE.START:
      return {
        ...state,
        loading: true,
      };
    case asyncActionTypes.RETRIEVE_CMS_AIRPORTS_LITE.SUCCESS:
      storage.set('airportsLiteCMS', { airports: action.payload.airports });
      return {
        ...state,
        loading: false,
        airportsLite: { airports: action.payload.airports },
      };
    case asyncActionTypes.RETRIEVE_CMS_AIRPORTS_LITE.FAIL:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default airportsLite;
